var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "transactions-section"
  }, [_c('b-container', {
    attrs: {
      "fluid": "xl"
    }
  }, [_c('h3', {
    staticClass: "title mb-4"
  }, [_vm._v("Transactions")]), _c('div', {
    staticClass: "history-table"
  }, [_c('div', {
    staticClass: "custom-search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.searchQuery,
      expression: "searchQuery"
    }],
    staticClass: "form-control custom-search-input",
    attrs: {
      "name": "search",
      "type": "text",
      "placeholder": "Search Requests"
    },
    domProps: {
      "value": _vm.searchQuery
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value;
      }, _vm.debounceSearch]
    }
  }), _c('div', {
    staticClass: "form-text"
  }, [_c('strong', [_vm._v("Note:")]), _c('small', [_vm._v(" You can search ID, Request, Address, Status")])])]), _vm.loading ? _c('div', {
    staticClass: "text-center my-5 py-5"
  }, [_c('div', {
    staticClass: "spinner-border",
    attrs: {
      "role": "status"
    }
  }, [_c('span', {
    staticClass: "visually-hidden"
  }, [_vm._v("Loading...")])])]) : _vm.transactions.length === 0 ? _c('div', {
    staticClass: "text-center my-5 py-5"
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v("No transactions found.")])]) : _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Transaction ID")]), _c('th', [_vm._v("Request No.")]), _c('th', [_vm._v("Amount")]), _c('th', [_vm._v("Wallet Address")]), _c('th', [_vm._v("Date")]), _c('th', [_vm._v("Time")]), _c('th', [_vm._v("Status")])])]), _c('tbody', _vm._l(_vm.transactions, function (txn, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(txn.transaction_id))]), _c('td', [_vm._v(_vm._s(txn.requestNo))]), _c('td', [_vm._v(_vm._s(txn.amount) + " "), _c('small', [_vm._v("BTC")])]), _c('td', [_vm._v(_vm._s(txn.binanceId))]), _c('td', [_vm._v(_vm._s(txn.date))]), _c('td', [_vm._v(_vm._s(txn.time))]), _c('td', [_c('b-badge', {
      attrs: {
        "pill": "",
        "variant": txn.statusClass
      }
    }, [_vm._v(_vm._s(txn.status))])], 1)]);
  }), 0)])])]), _vm.transactions.length > 0 ? _c('div', {
    staticClass: "my-4 d-flex flex-column flex-column-reverse flex-md-row justify-content-between align-items-center"
  }, [_c('div', {
    staticClass: "mt-3 mt-md-0"
  }, [_c('span', {
    staticClass: "text-muted text-sm"
  }, [_vm._v(" Showing " + _vm._s(_vm.getStartItem()) + " to " + _vm._s(_vm.getEndItem()) + " of " + _vm._s(_vm.meta.total) + " entries ")])]), _vm.meta.last_page > 1 ? _c('nav', [_c('ul', {
    staticClass: "pagination"
  }, [_c('li', {
    staticClass: "page-item",
    class: {
      disabled: _vm.meta.current_page === 1
    }
  }, [_c('a', {
    staticClass: "page-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.changePage(_vm.meta.current_page - 1);
      }
    }
  }, [_vm._v(" Previous ")])]), _vm._l(_vm.getPageNumbers(), function (page) {
    return _c('li', {
      key: page,
      staticClass: "page-item",
      class: {
        active: page === _vm.meta.current_page
      }
    }, [_c('a', {
      staticClass: "page-link",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function ($event) {
          $event.preventDefault();
          return _vm.changePage(page);
        }
      }
    }, [_vm._v(_vm._s(page))])]);
  }), _c('li', {
    staticClass: "page-item",
    class: {
      disabled: _vm.meta.current_page === _vm.meta.last_page
    }
  }, [_c('a', {
    staticClass: "page-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.changePage(_vm.meta.current_page + 1);
      }
    }
  }, [_vm._v(" Next ")])])], 2)]) : _vm._e()]) : _vm._e()])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }